import React, { useEffect } from 'react';
import ContactForm from '../compositions/ContactForm';
import { ContactFormManagementContextProvider, useContactFormManagement } from '../contexts/ContactFormManagementContext';
import { useGlobalContext } from '../contexts/GlobalContext';

const ContactFormWrapper: React.FC = () => {
    const { selectForm, clearSelection, currentFormId } = useContactFormManagement();
    const { useRoute: { routeParams } } = useGlobalContext();

    useEffect(() => {
        if (routeParams?.formId && routeParams.formId !== currentFormId) {
            selectForm(routeParams.formId);
        } else if (!routeParams?.formId && currentFormId) {
            clearSelection();
        }
    }, [routeParams?.formId, currentFormId, selectForm, clearSelection]);

    return <ContactForm />;
};

const ContactFormPage: React.FC = () => {
    return (
        <ContactFormManagementContextProvider>
            <ContactFormWrapper />
        </ContactFormManagementContextProvider>
    );
};

export default ContactFormPage;
